<template>
  <div class="v-boolean">
    <button class="v-boolean__button" @click="continueStep(false)">
      <v-lottie :options="dislikeOptions" :height="calch()" :width="calcw()" />
    </button>
    <button class="v-boolean__button" @click="continueStep(true)">
      <v-lottie :options="likeOptions" :height="calch()" :width="calcw()" />
    </button>
  </div>
</template>

<script>
import * as likeAnimation from "@/assets/animations/like-animation.json";
import * as dislikeAnimation from "@/assets/animations/dislike-animation.json";
import VLottie from "@/components/VLottie.vue";
import MixinMediaQuery from "@/services/mixins/mediaQuery";
import { mapState, mapMutations } from "vuex";

export default {
  name: "VBoolean",
  mixins: [MixinMediaQuery],
  components: {
    VLottie
  },
  data: () => ({
    likeOptions: {
      animationData: likeAnimation,
      autoplay: true,
      loop: true
    },
    dislikeOptions: {
      animationData: dislikeAnimation,
      autoplay: true,
      loop: true
    }
  }),
  computed: {
    ...mapState("Quiz", ["currentQuestion"])
  },
  methods: {
    ...mapMutations("Quiz", ["updateResponse"]),
    continueStep(value) {
      this.updateResponse({
        question: this.currentQuestion.uuid,
        response: value
      });

      this.$emit("continue", true);
    },
    calch() {
      if(window.outerWidth < 768 && window.outerHeight < 1024) {
        return "20vw";  
      }
      return "7vw";
      
    },
    calcw() {
      if(window.outerWidth < 768 && window.outerHeight < 1024) {
        return "20vw";
      }
      return "7vw";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.v-boolean {
  display: flex;
  justify-content: space-around;
  @media #{$large-and-up} {
  margin: 0 20% 0 20%;
  }
  &__button {
    border: none;
    background: #fff;
    outline: none;
    border-radius: 100%;
    padding: 24px;
    box-shadow: 0px 8px 8px rgba(36, 36, 36, 0.2);
  }
}
</style>
